import Resource from "./resource";

export class LicenseResource extends Resource {
    LicenseText: string;
    SerialNumber: string;
}
